<template>
  <v-row class="pa-0 " dense>
    <v-col>
      <v-row dense>
        <TitleCard 
          v-if="!showTitleCard()"
          test-id="transaction-interveners-title"
          :title="$vuetify.lang.t('$vuetify.transactionInterveners')" 
          class="my-4" icon="people_outline" 
        />
      </v-row>
     <v-row class="my-4" dense justify="end">
        <v-col v-if="transactionStatus.id !== 'invalid'" class="pa-0 pl-md-12" cols="12"
          test-id="transaction-intervener-card">
          <v-col v-if="transactionsInterveners()">
            <IntervenerCard v-for="(intervener, index) in transaction_content.interveners" :key="index" :index="index"
              :intervener="intervener"
              :sign-ceremony="transactionStatus.id === 'pending' && transaction_content.parameters && (transaction_content.parameters.find(p => p.key === 'signature_type')?.value === 'face-to-face')"
              :sign-ceremony-enabled="isCeremonyEnabled(intervener)"
              :transaction-finish="transactionStatus.id !== 'pending'" type="intervener"
              :test-id="`transaction-intervener-card-${index}`" />
          </v-col>
          <v-col v-else-if="!transactionsInterveners()">
            <IntervenerCard v-if="transactionsNoInterveners() && !transactionIsStandardNoInterveners()"
              :intervener="transaction_content.recipient_data" type="contact"
              test-id="transaction-intervener-card-contact" />
          </v-col>
        </v-col>
        <v-col v-else class="pl-md-14" test-id="transaction-interveners-not-detected">
          <span class="cts-color-tertiary cts-font-size-3">{{ $vuetify.lang.t('$vuetify.intervenersNotDetected')
            }}</span>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import const_global from "@/constants/global";
import const_icons from "@/constants/icons";
import TitleCard from "@/components/sections/transactions/components/TitleCard.vue";
import IntervenerCard from "@/components/sections/transactions/components/IntervenerCard.vue";
export default {
  name: "TransactionDetailIntervenersSection",
  components: {
    TitleCard,
    IntervenerCard,
  },
  data() {
    return {
      const_global,
      const_icons,
    };
  },
  props: {
    transactionStatus: Object,
    transaction_content: Object,
    transactionModel: String,
    capitalize: Function,
  },
  methods: {
    showTitleCard() {
      return (
        Array.isArray(this.transaction_content?.interveners) &&
        this.transaction_content?.interveners.length === 0 &&
        this.transactionModel === 'standard'
     )
      
    },
    transactionsInterveners(){
      return this.transaction_content?.interveners && this.transaction_content?.interveners.length > 0;
    },

    transactionIsStandardNoInterveners() {
        return(
          this.transactionModel === 'standard' &&
          Array.isArray(this.transaction_content?.interveners) &&
          this.transaction_content?.interveners.length === 0)
    },
    transactionsNoInterveners(){
      return (
        this.transactionModel !== 'email' && 
        this.transactionModel !== 'standard' &&
        this.transaction_content?.recipient_data &&    
        typeof this.transaction_content?.recipient_data !== 'string' && 
        this.transaction_content?.recipient_data.contact_id)
    },
    isCeremonyEnabled(intervener) {
      const transactionIsPending = this.transactionStatus.id === "pending";
      const transactionEvents = this.transaction_content.events;
      const intervenerEvents = transactionEvents.filter((event) => event.intervener === intervener.client_id);

      return transactionIsPending && !intervenerEvents.some((event) => event.key === "front_renderer_builder.intervener_finished");
    },
  }
};
</script>